module.exports = __webpack_public_path__ + "static/media/1.5-hour.4194d0ec.png";